function _transmitMessageSimple ({ txnId, processData, roomId, messageType, content, matrix, globalEventBus }) {
  matrix.sendEvent(roomId, messageType, content, txnId)
    .then((res) => {
      globalEventBus.emit('transmissionManager-messagecomplete', {
        success: true,
        txnId,
        roomId
      })
    })
    .catch((err) => {
      globalEventBus.emit('transmissionManager-messagecomplete', {
        success: false,
        txnId,
        roomId,
        err
      })
    })
  // console.log('fake fail')
  // globalEventBus.emit('transmissionManager-messagecomplete', {
  //  success: false,
  //  txnId,
  //  roomId,
  //  err: 'err'
  // })
}

async function _transmitMessageImage ({ txnId, processData, roomId, messageType, content, matrix, globalEventBus }) {
  // ---- 1. Upload the blob ----
  const uint8 = new Uint8Array(processData.imagedata)
  // Create a Blob from it
  const blob = new Blob([uint8], { type: processData.mimetype })

  const uploadResult = await matrix.uploadContent(blob, {
    name: processData.filename,
    type: processData.mimetype,
    rawResponse: false // we want {content_uri: "..."}
  })

  const mxcUrl = uploadResult.content_uri // Example: "mxc://server/id"

  content.url = mxcUrl

  matrix.sendEvent(roomId, messageType, content, txnId)
    .then((res) => {
      globalEventBus.emit('transmissionManager-messagecomplete', {
        success: true,
        txnId,
        roomId
      })
    })
    .catch((err) => {
      globalEventBus.emit('transmissionManager-messagecomplete', {
        success: false,
        txnId,
        roomId,
        err
      })
    })
}

function transmitMessage ({ txnId, processData, roomId, messageType, content, matrix, globalEventBus }) {
  const transmisisonFunctions = {
    simple: _transmitMessageSimple,
    image: _transmitMessageImage
  }
  if (typeof (transmisisonFunctions[processData.type]) === 'undefined') {
    console.log('ERROR transmit unknown message type', processData.type)
    return
  }
  transmisisonFunctions[[processData.type]]({ txnId, processData, roomId, messageType, content, matrix, globalEventBus })
}

export default {
  transmitMessage
}
